import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("sv_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config.url.includes("/auth/login")) {
      localStorage.removeItem("sv_token");
      if (window.location.pathname.startsWith("/admin")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export function fmtDuration(s) {
  s = Math.round(s || 0);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return h ? `${h}:${pad(m)}:${pad(sec)}` : `${pad(m)}:${pad(sec)}`;
}

export function getVisitorId() {
  let v = localStorage.getItem("sv_visitor");
  if (!v) {
    v = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`;
    localStorage.setItem("sv_visitor", v);
  }
  return v;
}

export function parseVideo(url) {
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return { kind: "youtube", id: yt[1] };
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return { kind: "vimeo", id: vm[1], url };
  return { kind: "file", src: url };
}

export const assetUrl = (path) => (path ? `${API}/public/asset/${path}` : "");
export const AVATAR_PRESETS = [1, 2, 3, 4, 5].map((i) => `/avatars/avatar-${i}.jpg`);
export const avatarSrc = (path) => (path?.startsWith("/avatars/") ? path : assetUrl(path));

export const DEFAULT_BRANDING = {
  logo_path: "", logo_position: "left", logo_size: "md",
  bg_type: "color", bg_color: "#070709", bg_image_path: "",
  theme: "dark", accent: "#EC4899",
  font_heading: "Outfit", font_body: "DM Sans",
  layout: "form-right", button_style: "pill", heading_color: "",
  form_mode: "inline", font_sizes: { title: 0, header: 0, description: 0, form_heading: 0, form_label: 0 },
};

export const DEFAULT_FORM = { fields: [], optins: [], legal: { parties: [], require_agree: false } };

export const mergeBranding = (b) => ({ ...DEFAULT_BRANDING, ...(b || {}), font_sizes: { ...DEFAULT_BRANDING.font_sizes, ...(b?.font_sizes || {}) } });
export const mergeForm = (f) => ({ fields: f?.fields || [], optins: f?.optins || [], legal: { parties: [], require_agree: false, ...(f?.legal || {}) } });
